import { EditOrganizerCategoriesV1 } from 'ck-queries';
import { useMutation } from '@tanstack/react-query';

import { fetchWithErrorThrowing } from 'ck-utils';
import toast from 'react-hot-toast';

export const useEditOrganizerCategories = (id: string) => {
  return useMutation({
    mutationFn: (data: EditOrganizerCategoriesV1) =>
      toast.promise(putEditOrganizerCategories(id, data), {
        loading: 'Laddar...',
        success: 'Kategorierna har uppdaterats',
        error: 'Kunde inte uppdatera kategorierna',
      }),
  });
};

function putEditOrganizerCategories(
  id: string,
  data: EditOrganizerCategoriesV1
) {
  return fetchWithErrorThrowing(`/committees/${id}/categories`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: new Headers({ 'content-type': 'application/json' }),
  });
}
